// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z_Hj","tabsBox":"styles_tabsBox__16ieo","createButton":"styles_createButton__3JQDh"};